import { render, staticRenderFns } from "./SelectWrapperCmp.vue?vue&type=template&id=c065564c&scoped=true&"
import script from "./SelectWrapperCmp.vue?vue&type=script&lang=js&"
export * from "./SelectWrapperCmp.vue?vue&type=script&lang=js&"
import style0 from "./SelectWrapperCmp.vue?vue&type=style&index=0&id=c065564c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c065564c",
  null
  
)

export default component.exports